import React from "react";
import {useState, useEffect} from "react";
import {getRunbookFeedbacks} from "store/actions";
import {useDispatch, useSelector} from "react-redux";

const AllFeedbacks = ({id}) => {
  const dispatch = useDispatch()
  const {feedbacks} = useSelector(state => ({feedbacks: state.AlertLog.feedbacks}))
  const [allFeedbacks, setAllFeedbacks] = useState(feedbacks || null);

  useEffect(() => {
    dispatch(getRunbookFeedbacks(id));
    setAllFeedbacks(feedbacks)
  }, [getRunbookFeedbacks])

  useEffect(() => {
    setAllFeedbacks(feedbacks);
  }, [feedbacks]);

  return (
    <React.Fragment>
      {allFeedbacks && allFeedbacks.length > 0 &&
      <div className="p-5 mb-4">
          <>
            <p className="mb-4" style={{fontSize: "1.2rem", color: "#DBE1F5"}}>Your previous feedback</p>
            <div className="border-bottom mt-2">
              <div className="d-flex">{Array.from({length: allFeedbacks?.rating}).map((_, index) => (
                <span style={{fontSize: "20px"}} key={index}>★</span>
              ))}</div>
              <p style={{color: "#DBE1F5"}}>{allFeedbacks?.textual_feedback}</p>
            </div>
          </>
      </div>
        }
    </React.Fragment>
  );
}

export default AllFeedbacks;